module.exports = __webpack_public_path__ + "static/media/HamSoiKoc.3b4b3c24.jpg";